import { Plugin } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';
import accordionIcon from './theme/icons/accordion.svg';
import './theme/accordion.css';
import { setAccordionState } from './utils';

export default class AccordionUI extends Plugin {
	init() {
		const editor = this.editor;

		// Usar el sistema de traducciones de CKEditor
        const insertAccordionLabel = editor.t('Insert accordion');

		editor.ui.componentFactory.add('insertAccordion', (locale) => {
			const command = editor.commands.get('insertAccordion');

			const buttonView = new ButtonView(locale);

			buttonView.set({
				label: insertAccordionLabel,
				icon: accordionIcon,
				tooltip: true,
			});

			buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');

			this.listenTo(buttonView, 'execute', () => editor.execute('insertAccordion'));

			return buttonView;
		});

		this._setupEventListeners();
	}

	_setupEventListeners() {
		const editor = this.editor;
		const viewDocument = editor.editing.view.document;

		this.listenTo(viewDocument, 'keydown', (evt, data) => this._handleKeyDown(evt, data));
		this.listenTo(viewDocument, 'click', (evt, data) => this._handleClick(evt, data));
	}

	_handleKeyDown(evt, data) {
		const editor = this.editor;
		const targetElement = editor.editing.mapper.toModelElement(data.target);

		if (targetElement && targetElement.name === 'accordionTitle') {
			switch (data.keyCode) {
				case 32: // Spacebar
					this._preventDetailsToggling(evt, data);
					break;
				case 13: // Enter
					this._handleEnterKey(targetElement, editor, data);
					break;
			}
		}
	}

	_handleEnterKey(targetElement, editor, data) {
		const accordion = targetElement.parent;
		const accordionId = accordion.getAttribute('id');
		const accordionContent = accordion.getChild(1);
		const accordionEl = document.querySelector(`[data-id='${accordionId}']`);

		if (accordionEl.getAttribute('open') === 'true') {
			editor.model.change((writer) => {
				writer.setSelection(accordionContent, 0);
			});
		} else {
			editor.execute('insertParagraph', {
				position: editor.model.createPositionAfter(accordion.parent),
			});
		}
	}

	_preventDetailsToggling(evt, data) {
		data.domEvent.preventDefault();
		const editor = this.editor;
		editor.model.change((writer) => {
			const selection = editor.model.document.selection;
			const insertPosition = selection.getFirstPosition();
			writer.insertText(' ', insertPosition);
		});
	}

	_handleClick(evt, data) {
		const editor = this.editor;
		const targetElement = editor.editing.mapper.toModelElement(data.target);

		if (targetElement && targetElement.name === 'accordionTitle') {
			data.domEvent.preventDefault();
			data.domEvent.stopPropagation();

			if (data.domEvent.offsetX < 16) {
				const accordionEl = data.domTarget.parentElement;
				accordionEl.toggleAttribute('open');

				const accordionId = accordionEl.getAttribute('data-id');
				const isOpen = accordionEl.getAttribute('open') !== null;
				setAccordionState(accordionId, isOpen);
			}
		}
	}
}
